import IconSVG from '../../styles/svg-icons';
import { ActionBlockerProps } from './ActionBlocker';
import { EvalActionBlocker } from './EvalActionBlocker';

export const EvalValueBlocker = ({ children, ...restProps }: ActionBlockerProps) => {
    return (
        <EvalActionBlocker {...restProps}>
            {blocked => blocked
                ? <IconSVG width="16" height="16" name="subscribe-lock-grey" />
                : <>{children}</>
            }
        </EvalActionBlocker>
    );
};
